/* ================================================================
   LUMÉA — interacciones propias (vanilla, sin librerías)
   ================================================================ */
(function () {
  'use strict';

  // La hoja se incluye desde cada sección; ejecútala una sola vez.
  if (window.__lmAppInit) return;
  window.__lmAppInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.lm-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave en heros ---------- */
  function initParallax() {
    if (reduceMotion) return;
    var layers = document.querySelectorAll('[data-lm-parallax]');
    if (!layers.length) return;
    var ticking = false;
    function update() {
      layers.forEach(function (layer) {
        var rect = layer.getBoundingClientRect();
        var speed = parseFloat(layer.getAttribute('data-lm-parallax')) || 0.12;
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
        layer.style.transform = 'scale(1.12) translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Marquesina: el contenido ya va duplicado desde Liquid ---------- */
  function initMarquee() { /* no-op: bucle resuelto en CSS + Liquid */ }

  /* ---------- Hero: parallax al mover el cursor ---------- */
  function initHero() {
    var hero = document.querySelector('[data-lm-hero]');
    if (!hero || reduceMotion) return;
    var layers = hero.querySelectorAll('[data-lm-hero-depth]');
    if (!layers.length) return;
    var raf = null, tx = 0, ty = 0;
    function apply() {
      layers.forEach(function (el) {
        var d = parseFloat(el.getAttribute('data-lm-hero-depth')) || 12;
        el.style.transform = 'translate3d(' + (tx * d).toFixed(2) + 'px,' + (ty * d).toFixed(2) + 'px,0)';
      });
      raf = null;
    }
    hero.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      var r = hero.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * -1;
      ty = ((e.clientY - r.top) / r.height - 0.5) * -1;
      if (!raf) raf = requestAnimationFrame(apply);
    });
    hero.addEventListener('pointerleave', function () {
      tx = 0; ty = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    });
  }

  /* ---------- Barra de compra flotante ---------- */
  function initStickyBar() {
    var bar = document.querySelector('[data-lm-stickybar]');
    if (!bar) return;
    var anchor = document.querySelector('[data-lm-hero]') ||
      document.querySelector('.lm-hero2') ||
      document.querySelector('main .shopify-section');
    var shown = false;
    function check() {
      var trigger = anchor ? anchor.getBoundingClientRect().bottom < 40 : window.scrollY > 600;
      // ocultar cuando el pie está a la vista
      var footer = document.querySelector('.section-group-footer-group, [class*="footer"]');
      var nearFooter = false;
      if (footer) {
        var fr = footer.getBoundingClientRect();
        nearFooter = fr.top < window.innerHeight - 40;
      }
      var want = trigger && !nearFooter;
      if (want !== shown) {
        shown = want;
        bar.classList.toggle('is-visible', shown);
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- Barra de anuncios auto-rotativa ---------- */
  function initAnuncio() {
    document.querySelectorAll('[data-lm-anuncio]').forEach(function (bar) {
      var msgs = bar.querySelectorAll('.lm-anuncio__msg');
      if (msgs.length < 2) return;
      var speed = (parseFloat(bar.getAttribute('data-speed')) || 4) * 1000;
      var i = 0;
      var timer = null;
      function show(n) {
        msgs[i].classList.remove('is-active');
        i = (n + msgs.length) % msgs.length;
        msgs[i].classList.add('is-active');
      }
      function start() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, speed); }
      function stop() { clearInterval(timer); }
      start();
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
    });
  }

  /* ---------- Comparador antes/después ---------- */
  function initCompare() {
    document.querySelectorAll('.lm-compare').forEach(function (el) {
      var set = function (clientX) {
        var rect = el.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(2, Math.min(98, pct));
        el.style.setProperty('--lm-split', pct + '%');
      };
      var active = false;
      el.addEventListener('pointerdown', function (e) { active = true; set(e.clientX); });
      window.addEventListener('pointermove', function (e) { if (active) set(e.clientX); });
      window.addEventListener('pointerup', function () { active = false; });
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse' && !active) set(e.clientX);
      });
    });
  }

  /* ---------- Cifras animadas (count-up) ---------- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-lm-count]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        if (reduceMotion) { el.textContent = el.getAttribute('data-lm-count'); return; }
        var target = parseFloat(el.getAttribute('data-lm-count'));
        var suffix = el.getAttribute('data-lm-suffix') || '';
        var dur = 1400, start = performance.now();
        function tick(now) {
          var p = Math.min(1, (now - start) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target % 1 ? (target * eased).toFixed(1) : Math.round(target * eased)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Carrusel de reseñas (táctil + puntos + auto) ---------- */
  function initCarousel() {
    document.querySelectorAll('[data-lm-carousel]').forEach(function (root) {
      var track = root.querySelector('.lm-carousel');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.lm-rcard'));
      if (!cards.length) return;
      var prev = root.querySelector('[data-lm-prev]');
      var next = root.querySelector('[data-lm-next]');
      var dotsWrap = root.querySelector('[data-lm-dots]');
      var autoplay = root.getAttribute('data-lm-autoplay') === 'true' && !reduceMotion;
      var index = 0;
      var timer = null;

      var dots = [];
      if (dotsWrap) {
        cards.forEach(function (c, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'lm-carousel__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Reseña ' + (i + 1));
          d.addEventListener('click', function () { go(i, true); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }

      function scrollToCard(i) {
        var target = cards[i].offsetLeft - track.offsetLeft;
        try { track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' }); }
        catch (e) { track.scrollLeft = target; }
        setTimeout(function () {
          if (Math.abs(track.scrollLeft - target) > 6) track.scrollLeft = target;
        }, 70);
      }
      function sync() {
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === cards.length - 1;
      }
      function go(i, user) {
        index = Math.max(0, Math.min(cards.length - 1, i));
        scrollToCard(index);
        sync();
        if (user) restart();
      }
      function nextSlide() { go(index + 1 >= cards.length ? 0 : index + 1); }

      if (prev) prev.addEventListener('click', function () { go(index - 1, true); });
      if (next) next.addEventListener('click', function () { go(index + 1, true); });

      // Mantener el punto activo al deslizar con el dedo
      var scrollT = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, bestDist = Infinity;
          cards.forEach(function (c, i) {
            var center = c.offsetLeft - track.offsetLeft + c.offsetWidth / 2;
            var dist = Math.abs(center - mid);
            if (dist < bestDist) { bestDist = dist; best = i; }
          });
          if (best !== index) { index = best; sync(); }
        }, 120);
      }, { passive: true });

      function start() { if (autoplay) { clearInterval(timer); timer = setInterval(nextSlide, 5500); } }
      function stop() { clearInterval(timer); }
      function restart() { stop(); start(); }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('touchstart', stop, { passive: true });
      root.addEventListener('focusin', stop);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

      sync();
      start();
    });
  }

  /* ---------- Simulador de resultados (cierre) ---------- */
  function initTimeline() {
    document.querySelectorAll('[data-lm-timeline]').forEach(function (root) {
      var slider = root.querySelector('[data-lm-tl-slider]');
      var dayEl = root.querySelector('[data-lm-tl-day]');
      var capEl = root.querySelector('[data-lm-tl-caption]');
      var dataEl = root.querySelector('[data-lm-tl-hitos]');
      if (!slider) return;
      var hitos = [];
      try { hitos = JSON.parse(dataEl.textContent) || []; } catch (e) {}
      hitos.sort(function (a, b) { return a.dia - b.dia; });

      var afterImg = root.querySelector('.lm-timeline__after');
      function update() {
        var day = parseInt(slider.value, 10) || 1;
        var ratio = (day - 1) / 29;
        root.style.setProperty('--p', (ratio * 100).toFixed(1) + '%');
        if (afterImg) afterImg.style.opacity = (0.12 + ratio * 0.88).toFixed(3);
        if (dayEl) dayEl.textContent = day;
        // hito activo: el de mayor 'dia' que no supere el día actual
        var active = hitos[0];
        for (var i = 0; i < hitos.length; i++) {
          if (hitos[i].dia <= day) active = hitos[i];
        }
        if (active && capEl) {
          capEl.innerHTML = '<strong></strong><span></span>';
          capEl.querySelector('strong').textContent = active.titulo;
          capEl.querySelector('span').textContent = active.texto;
        }
      }
      slider.addEventListener('input', update);
      update();
    });
  }

  /* ---------- FAQ acordeón ---------- */
  function initFaq() {
    document.querySelectorAll('.lm-faq__item').forEach(function (item) {
      var q = item.querySelector('.lm-faq__q');
      var a = item.querySelector('.lm-faq__a');
      if (!q || !a) return;
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery() {
    document.querySelectorAll('[data-lm-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-lm-gallery-main]');
      var thumbs = root.querySelectorAll('[data-lm-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (full) main.src = full;
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Selector de variantes de producto ---------- */
  function initVariants() {
    document.querySelectorAll('[data-lm-product]').forEach(function (root) {
      var dataEl = root.querySelector('[data-lm-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelector('[data-lm-price-now]');
      var priceWas = root.querySelector('[data-lm-price-was]');
      var perUnit = root.querySelector('[data-lm-perunit]');
      var submit = root.querySelector('[data-lm-add]');
      var addLabel = submit ? submit.getAttribute('data-label-add') : 'Añadir';
      var soldLabel = submit ? submit.getAttribute('data-label-sold') : 'Agotado';
      var selects = root.querySelectorAll('[data-lm-option]');

      function currentOptions() {
        return Array.prototype.map.call(selects, function (s) {
          var checked = s.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      function update() {
        var opts = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceNow) priceNow.textContent = match.price_money;
        if (priceWas) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceWas.textContent = match.compare_money;
            priceWas.hidden = false;
          } else { priceWas.hidden = true; }
        }
        if (perUnit) {
          if (match.units > 1) {
            perUnit.textContent = match.perunit_money + ' / unidad';
            perUnit.hidden = false;
          } else {
            perUnit.hidden = true;
            perUnit.textContent = '';
          }
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? addLabel : soldLabel;
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  /* ---------- "X personas viendo" con ligera fluctuación ---------- */
  function initViewers() {
    document.querySelectorAll('[data-lm-viewers]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 10;
      var max = parseInt(el.getAttribute('data-max'), 10) || 40;
      if (max < min) { var t = max; max = min; min = t; }
      function rand() { return Math.floor(min + Math.random() * (max - min + 1)); }
      el.textContent = rand();
      if (reduceMotion) return;
      setInterval(function () {
        var cur = parseInt(el.textContent, 10) || min;
        var next = cur + (Math.random() < 0.5 ? -1 : 1) * (1 + Math.floor(Math.random() * 3));
        if (next < min) next = min + 1;
        if (next > max) next = max - 1;
        el.textContent = next;
      }, 4000 + Math.random() * 3000);
    });
  }

  function boot() {
    initReveal();
    initViewers();
    initAnuncio();
    initHero();
    initStickyBar();
    initParallax();
    initMarquee();
    initCompare();
    initCountUp();
    initCarousel();
    initTimeline();
    initFaq();
    initGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
